import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { ErrorStatusProps } from './ErrorStatus.connect';
import { connectErrorStatus } from './ErrorStatus.connect';

export const Component: FC<ErrorStatusProps> = ({ message }) => {
  const { formatMessage } = useIntl();
  const formattedMessage = formatMessage({ id: message as IntlKey, defaultMessage: message });
  const truncatedMessage = formattedMessage.length > 256 ? formattedMessage.substr(0, 256) + '...' : formattedMessage;
  return (
    <div className="w-100 alert alert-discreet-danger mb-0 px-0" data-e2e="errors-panel">
      <div className="card-body">
        <div>
          <i className="icon icon-sm me-3">cancel</i>
          <strong className="align-middle">{truncatedMessage}</strong>
        </div>
      </div>
    </div>
  );
};

export const ErrorStatus = connectErrorStatus(Component);

ErrorStatus.displayName = 'ErrorStatus';
